import { useEffect, useState } from 'react';
import React from 'react';
export const dispatchReactComponentUpdate = (instance, config) => {
    var _a;
    const event = new CustomEvent(`react-edge-update`, { detail: config });
    (_a = instance === null || instance === void 0 ? void 0 : instance.oflowEdgeDom) === null || _a === void 0 ? void 0 : _a.dispatchEvent(event);
};
export const useReactEdgeConfig = (instance) => {
    const edgeConfig = instance.getConfig();
    const { highlight } = instance;
    const [config, setConfig] = useState(Object.assign(Object.assign({}, edgeConfig), { highlight }));
    useEffect(() => {
        var _a;
        const listener = data => {
            setConfig(data.detail);
        };
        (_a = instance === null || instance === void 0 ? void 0 : instance.oflowEdgeDom) === null || _a === void 0 ? void 0 : _a.addEventListener('react-edge-update', listener);
        return () => {
            var _a;
            (_a = instance === null || instance === void 0 ? void 0 : instance.oflowEdgeDom) === null || _a === void 0 ? void 0 : _a.removeEventListener(`react-edge-update`, listener);
        };
    }, []);
    return [config, instance.setConfig];
};
export const ReactComponentWrapper = (props) => {
    const { instance, shapeInfo } = props;
    const { ReactComponent } = instance.constructor;
    const [config, setConfig] = useReactEdgeConfig(instance);
    const { animated } = config;
    return (React.createElement("g", { "oflow-element-id": instance === null || instance === void 0 ? void 0 : instance.id, className: `react-flow__edge ${animated ? 'animated' : ''}` },
        React.createElement(ReactComponent, { config: config, setConfig: setConfig, instance: instance, shapeInfo: shapeInfo })));
};
//# sourceMappingURL=index.js.map